/**
 *  This file is replaced in non development mode by appropriate
 *  file configuration.
 */

/**
 * Development/Test (default)
 *
 * A development/test configuration of an application with
 * all sub applications modules included.
 *
 * This configuration is byu default used when we use ng b / ng serve
 * without any flags and configuration specified.
 */
export const environment = {
    name: '(default)',
    production: false,
    version: '1.7.0',
    secureCookie: false,

    applicationBaseUrl: 'https://systems-overview-integration.viessmann-climatesolutions.com/',

    /**
     * Main API-Middleware URL.
     */
    //apiUrl: 'http://localhost:8080/v1',
    //apiUrlV2: 'http://localhost:8080/v2',
    apiUrl: 'https://api-integration.viessmann-climatesolutions.com/service-and-maintenance/heating-systems-overview/v1',
    apiUrlV2: 'https://api-integration.viessmann-climatesolutions.com/service-and-maintenance/heating-systems-overview/v2',

    /**
     * Full URL for getting CSRF Token for Authorization.
     */
    csrfAuthUrl: 'https://api-integration.viessmann-climatesolutions.com/auth/v1/saml/csrf',

    /**
     * Full URL for user information.
     */
    usersMe: 'https://api-integration.viessmann-climatesolutions.com/users/v1/users/me?sections=roles&sections=identity&sections=sales',

    /**
     * Full URL for header.
     */
    headerBaseUrl: 'https://api-integration.viessmann-climatesolutions.com',

    /**
     * Full URL for account data via header.
     */
    headerAccountAppUrl: 'https://account-integration.viessmann-climatesolutions.com',

    /**
     * URL for Vibooks with query param
     */
    viBooks: 'https://vibooks-integration.viessmann-climatesolutions.com/{countryCode}/{languageCode}?query={systemId}&utm_source=heating_systems_overview',

    /**
     * Full URL for Viguide installations
     */
    viGuideBaseUrl: 'https://viguide-integration.viessmann-climatesolutions.com/installations?utm_source=heating_systems_overview',

    /**
     * Full URL for Viguide installations
     */
    viGuide: 'https://viguide-integration.viessmann-climatesolutions.com/installations/{installationId}?utm_source=heating_systems_overview',

    /**
     * Full URL for heating-system-registration-b2b for specific equipment
     */
    heatingSystemRegistrationEqui: 'https://system-registration-integration.viessmann-climatesolutions.com/open/{systemId}?utm_source=heating_systems_overview_change',

    /**
     * Full URL for heating-system-registration-b2b
     */
    heatingSystemRegistrationSerialnumber:  'https://system-registration-integration.viessmann-climatesolutions.com?serialnumber={serialNumber}&utm_source=heating_systems_overview_create',

    /**
     * Full URL for heating-system-registration-b2b
     */
    heatingSystemRegistrationSerialnumberChange:  'https://system-registration-integration.viessmann-climatesolutions.com?serialnumber={serialNumber}&utm_source=heating_systems_overview_change',

    /**
     * Full URL for heating-system-registration-b2b
     */
    heatingSystemRegistrationBase:  'https://system-registration-integration.viessmann-climatesolutions.com?utm_source=heating_systems_overview_create',

    /**
     * Full URL for heating-system-registration-b2b API
     */
    heatingSystemRegistrationApi: 'https://api-integration.viessmann-climatesolutions.com/service-and-maintenance/heating-system-reg-b2b/api/',

    /**
     * URL data protection declaration
     */
    dataProtection: 'https://legal-policies.viessmann-climatesolutions.com/{b2x}/common/privacy-policy.html',

    /**
     * URL imprint
     */
    imprint: 'https://legal-policies.viessmann-climatesolutions.com/{b2x}/common/imprint.html',

    IAMConfig: {
        auth: {
            baseUrl: 'https://api-integration.viessmann-climatesolutions.com/',
            appId: 'heating-systems-overview'
        }
    },


    /**
     * URL Shop by material number
     */
    shopUrl: 'https://shop-test.viessmann-climatesolutions.com/details/',

    /**
     * URL Shop by serial number
     */
    shopSerialUrl: 'https://shop-test.viessmann-climatesolutions.com/service',

    /**
     * URL Shop by serial number
     */
    shopOfferUrl: 'https://shop-test.viessmann-climatesolutions.com/offers',

    /**
     * URL Partner-Portal Country and Language dependent
     */
    partnerPortalUrl: 'https://partnerportal-staging.viessmann-climatesolutions.com/{countryCode}/{languageCode}/',

    /**
     * Partner-Portal Process-Form addition de
     */
    partnerPortalDE_ATFormProcess: 'support/kundenvorgangsuebersicht.html?coOverviewType=service-order&coDetailsId=',

    /**
     * Partner-Portal TD-Form addition DE
     */
    partnerPortalDEFormGeneral: 'support/online-anfrage-stellen.html',

    /**
     * Partner-Portal TD-Form addition DE
     */
    partnerPortalDEFormService: 'support/online-anfrage-stellen.html?orderData.serviceOperationNumber=',

    /**
     * Partner-Portal TD-Form addition AT
     */
    partnerPortalATFormGeneral: 'support/online-anfrage-stellen.html',

    /**
     * Partner-Portal TD-Form addition AT
     */
    partnerPortalATFormService: 'support/online-anfrage-stellen.html?orderData.serviceOperationNumber=',

    /**
     * Partner-Portal TD-Form addition NL
     */
    partnerPortalNLFormGeneral: 'td-technische-dienst/aanvragen-aan-de-technische-dienst.html',

    /**
     * Partner-Portal TD-Form addition NL
     */
    partnerPortalNLFormService: 'td-technische-dienst/aanvragen-aan-de-technische-dienst/td-vraag-over-interventie.html?orderData.orderNumber=',

    /**
     * Partner-Portal TD-Form addition FR
     */
    partnerPortalFRFormGeneral: 'installation-und-service/demandes-au-service-technique.html',

    /**
     * Partner-Portal TD-Form addition FR
     */
    partnerPortalFRFormService: 'installation-und-service/demandes-au-service-technique/td-question-sur-une-intervention.html?orderData.orderNumber=',

    /**
     * Partner-Portal TD-Form addition IT
     */
    partnerPortalITFormGeneral: 'Servizio_autorizzato_assistenza/richiesta_di_supporto.html',

    /**
     * Partner-Portal TD-Form addition IT
     */
    partnerPortalITFormService: 'Servizio_autorizzato_assistenza/richiesta_di_supporto.html?orderData.serviceOperationNumber=',

    /**
     * Parter-Portal Control Url DE
     */
    partnerPortalControlUrlDE: 'support/online-anfrage-stellen/td-anfrage/buchung-leitwarten-service.html?serialNumber={serialnumber}',

    /**
     * URL Partner-Portal
     */
    partnerPortalBaseUrl: 'https://partnerportal-staging.viessmann-climatesolutions.com',

    /**
     * URL service-configurator
     */
    serviceConfiguratorUrl: 'https://sc-integration.viessmann-climatesolutions.com/configuration/new?equipmentId={equipmentId}&utm_source=heating_systems_overview',

    /**
     * URL For SAP-Maintenance Information
     */
    statusPage: 'https://api-integration.viessmann-climatesolutions.com/status/v1/apps/ydn2lvc56h36/summary',

    /**
     * Flag if SAP-Status should be checked
     */
    statusCheckActive: false,

    /**
     * URL for registration b2c
     */
    endCustomerRegistration: 'https://account-integration.viessmann-climatesolutions.com/register-end-customer?address=true',

    /**
     * URL for registration b2b
     */
    customerRegistration: 'https://account-integration.viessmann-climatesolutions.com/register?hideNoCompanyNumberOption=true',

    translationUrl: 'https://api-integration.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/a07a6c3a6e4b327945561d46d852905c/locales/',

    /**
     * URL Fiori
     */
    fioriEquipmentUrl: 'https://fiori-test.viessmann-climatesolutions.com/fiori#ZCS_EQUI_MASTER_DATA_SHEET-display?equipment={equipment}&sap-app-origin-hint=&/equipment/{equipment}',

    /**
     * URL Account Personal Data
     */
    accountMaintenanceUrl: 'https://account-integration.viessmann-climatesolutions.com/personal-data?redirect={redirect}&originApp={title}',

    /**
     * URL Account Personal Data
     */
    accountContactMaintenanceUrl: 'https://account-integration.viessmann-climatesolutions.com/notifications?redirect={redirect}&originApp={title}',

    /**
     * URL Become Partner DE
     */
    becomePartnerUrlDE: 'https://www.viessmann.de/de/kontakt/anfragen/fachpartner-werden.html',

    /**
     * URL Become Partner FR
     */
    becomePartnerUrlFR: 'https://www.viessmann.fr/fr/professionnels/devenir-partenaire/form-devenir-partenaire.html',

    /**
     * URL Become Partner BE
     */
    becomePartnerUrlBE: 'https://www.viessmann.be/nl/contact/aanvraag-installateur-worden.html',

    /**
     * URL Become Partner LU
     */
    becomePartnerUrlLUde: 'https://www.viessmann.lu/de/kontakt/fachpartner-werden.html',

    /**
     * URL Become Partner LU/fr
     */
    becomePartnerUrlLUfr: 'https://www.viessmann.lu/fr/contact/demande-devenir-installateur.html',

    /**
     * URL Become Partner NL
     */
    becomePartnerUrlNL: 'https://www.viessmann.nl/nl/contact/aanvraag-installateur-worden.html',

    /**
     * URL Become Partner IT
     */
    becomePartnerUrlIT: 'https://www.viessmann.it/it/contattaci/residenziale-professionista.html',

    /**
     * URL Become Partner SK
     */
    becomePartnerUrlSK: 'https://www.viessmann-partner.sk/sk/register-public',

    /**
     * URL Become Partner CZ
     */
    becomePartnerUrlCZ: 'https://www.viessmann-partner.cz/CZ/register-public',

    /**
     * URL Become Partner DK
     */
    becomePartnerUrlDK: 'https://www.viessmann.dk/da/din-forespoergsel.html',

    /**
     * URL Become Partner AT
     */
    becomePartnerUrlAT: 'https://www.viessmann.at/de/kontakt/formulare/fachpartner-werden.html',

    /**
     * URL Become Partner SI
     */
    becomePartnerUrlSI: 'https://www.viessmann.si/sl/strokovnjaki/specializirani-obrtniki/instalaterji.html',

    /**
     * URL UserPortal
     */
    userPortalUrl: 'https://home-integration.viessmann-climatesolutions.com',

    /**
     * URL UserPortal de
     */
    userPortalUrlDe: 'https://home-integration.viessmann-climatesolutions.com/{countryCode}/{languageCode}/anlagen.html',

    /**
     * URL UserPortal fr
     */
    userPortalUrlFr: 'https://home-integration.viessmann-climatesolutions.com/{countryCode}/{languageCode}/installations.html',

    /**
     * URL UserPortal it
     */
    userPortalUrlIt: 'https://home-integration.viessmann-climatesolutions.com/{countryCode}/{languageCode}/sistemi.html',

    /**
     * URL Supportlink for Partner Portal AT
     */
    atPartnerPortalSupportLink: 'https://partnerportal-integration.viessmann-climatesolutions.com/at/de/support/online-anfrage-stellen.html?additionalInfo.description=Anlagen%C3%BCbersicht'


};
